/**
 * PostHog Analytics Event Names
 * 
 * Centralized constants for all PostHog event tracking.
 * Use these constants instead of string literals to prevent typos
 * and enable better IDE autocomplete support.
 */

// Application Lifecycle Events
export const POSTHOG_EVENT_APPLICATION_STARTED = 'Application Started';

// Authentication Events
export const POSTHOG_EVENT_LOGIN = 'Login';
export const POSTHOG_EVENT_FORGOT_PASSWORD = 'Forgot Password';

// Admin Navigation Events
export const POSTHOG_EVENT_COURSE_BUILDER_ADMIN_LOGIN = 'Course builder admin login';
export const POSTHOG_EVENT_AUDIT_ADMIN_LOGIN = 'Audit admin login';

// Management Events
export const POSTHOG_EVENT_ADD_ORGANIZATION = 'Add Organization';

// Learning Center Events
export const POSTHOG_EVENT_REGISTER_INTEREST = 'Register interest';

// Daily D.O.S.E. Events
export const POSTHOG_EVENT_DAILY_DOSE_DOC = 'Daily D.O.S.E. doc';
export const POSTHOG_EVENT_DAILY_DOSE_LETS_GO = "Daily D.O.S.E. Let's Go";
export const POSTHOG_EVENT_FAVOURITE_DAILY_DOSE = 'Favriout Daily D.O.S.E.';
export const POSTHOG_EVENT_LATEST_DAILY_DOSE_PODCAST_PLAY = 'Leatest Daily D.O.S.E. Podcast play';
export const POSTHOG_EVENT_SAVE_COMMENT_DAILY_DOSE = 'save comment for Daily D.O.S.E';

// Video Events
export const POSTHOG_EVENT_CARE_MINIS = 'C.A.R.E™ MINI\'S';

// Analytics Events
export const POSTHOG_EVENT_EXPORT_ANALYTICS_PROGRAM_LIST = 'Export analytics program list';
export const POSTHOG_EVENT_SHOW_ANALYTICS_PROGRAM_LIST = 'Show analytics program list';
export const POSTHOG_EVENT_HIDE_ANALYTICS_PROGRAM_LIST = 'Hide analytics program list';
